(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bn-withdrawal"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KEY = 'bn-withdrawal';

    const stamp = (lang) => {
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('fr-FR', {
          timeZone: 'Europe/Paris',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        })
          .formatToParts(new Date())
          .map((p) => [p.type, p.value])
      );
      const date = `${parts.day}/${parts.month}/${parts.year}`;
      const time = lang === 'fr' ? `${parts.hour} h ${parts.minute}` : `${parts.hour}:${parts.minute}`;
      return { date, time };
    };

    const read = () => {
      try {
        return JSON.parse(sessionStorage.getItem(KEY) || 'null');
      } catch {
        return null;
      }
    };

    const write = (data) => {
      try {
        sessionStorage.setItem(KEY, JSON.stringify(data));
      } catch {}
    };

    const init = (root) => {
      if (root.dataset.bnWdReady) return;
      root.dataset.bnWdReady = '1';
      const lang = root.dataset.lang;

      const sent = root.querySelector('[data-bn-wd-sent]');
      if (sent) {
        const data = read();
        if (!data) return;
        sent.querySelector('[data-bn-wd-date]').textContent = data.date;
        sent.querySelector('[data-bn-wd-time]').textContent = data.time;
        sent.querySelectorAll('[data-bn-wd-show]').forEach((dd) => {
          dd.textContent = data[dd.dataset.bnWdShow] || '';
        });
        sent.querySelector('[data-bn-wd-recap]').hidden = false;
        return;
      }

      const start = root.querySelector('[data-bn-wd-start]');
      const form = root.querySelector('.bn-wd__form');
      if (!form) return;

      /* From the order e-mail: ?commande=1023 fills the order number */
      const order = new URLSearchParams(location.search).get('commande');
      const orderField = form.querySelector('[data-bn-wd-field="order"]');
      if (order && orderField && !orderField.value) orderField.value = order.replace(/[^\w#-]/g, '').slice(0, 20);

      /* ?etape=formulaire: the fields are open from the first paint (the script at the top of the section); the
         button's state follows. Focus goes to the title, on every device and without scrolling: a screen reader
         announces it and reads on into the form, and the next Tab lands in « Nom » (while Shopify's cookie banner is
         up, its own script sends that first Tab to the banner). No field takes focus by itself: on a phone that would
         open the keyboard over the page, and Shopify's spam check binds on a field's first focus, so its badge would
         pop into the corner with no action from the visitor. The form's hidden h2 is not used: Horizon's
         .visually-hidden shows on focus and would push the fields down. The title only takes focus when nothing has it
         yet: on a slow connection the fields are open well before this script arrives, and a visitor already typing
         in a field (or in the cookie banner) keeps the caret and the phone keyboard. After an error or a sent request
         there is no step 1 and nothing changes. */
      if (start && root.hasAttribute('data-bn-wd-open')) {
        start.setAttribute('aria-expanded', 'true');
        start.hidden = true;
        form.querySelector('[data-bn-wd-fields]').classList.add('is-open');
        const title = root.querySelector('.bn-wd__title');
        const active = document.activeElement;
        if (title && (!active || active === document.body || active === document.documentElement)) {
          title.tabIndex = -1;
          title.focus({ preventScroll: true });
        }
      }

      start?.addEventListener('click', () => {
        start.setAttribute('aria-expanded', 'true');
        start.hidden = true;
        form.querySelector('[data-bn-wd-fields]').classList.add('is-open');
        form.querySelector('[data-bn-wd-field="name"]')?.focus();
      });

      form.addEventListener('submit', () => {
        const values = {};
        form.querySelectorAll('[data-bn-wd-field]').forEach((field) => {
          values[field.dataset.bnWdField] = field.value.trim();
        });
        const ack = form.querySelector('[data-bn-wd-ack]');
        const items = values.items || ack.dataset.all;
        const { date, time } = stamp(lang);
        form.querySelector('[data-bn-wd-stamp]').value = `${date} ${time.replace(/ /g, ' ')} (Paris)`;
        ack.value = ack.dataset.template
          .replaceAll('[nom]', values.name)
          .replaceAll('[date]', date)
          .replaceAll('[heure]', time.replace(/ /g, ' '))
          .replaceAll('[commande]', values.order)
          .replaceAll('[produits]', items);
        write({ ...values, items, date, time });
      });
    };

    document.querySelectorAll('[data-bn-wd]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-bn-wd]').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
